/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "OwnershipCycle",
        type: "error",
    },
    {
        inputs: [],
        name: "entryPoint",
        outputs: [
            {
                internalType: "contract IEntryPoint",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint8",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint8",
                name: "operation",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "txGas",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "getNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
        ],
        name: "isOperator",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "magicValue",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "isValidSigner",
        outputs: [
            {
                internalType: "bytes4",
                name: "magicValue",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "receivedTokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "tokenContract",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "missingAccountFunds",
                type: "uint256",
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "validationData",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ERC1155TokenboundMech__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ERC1155TokenboundMech__factory.bytecode = _bytecode;
ERC1155TokenboundMech__factory.abi = _abi;
